import Vue from 'vue'
import Router from 'vue-router'
import RecordsList from '@/components/RecordsList'
import Admin from '@/components/Admin'
import Login from '@/components/Login'
import firebase from 'firebase'
import { store } from '../store/store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'recordsList',
      component: RecordsList
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresGuest: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  //Check for requireAuth guard
  if( to.matched.some(record => record.meta.requiresAuth) ) {
    
    //Check if NOT logget in
    if ( store.getters.user === null || store.getters.user === undefined ) {
      //Go to login-page
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if( to.matched.some(record => record.meta.requiresGuest) ) {
    if ( store.getters.user !== null && store.getters.user !== undefined ) {
      next({
        path: '/admin',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js